import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'foundations-components/transitional/components/List';
import { Flex } from 'foundations-components/components/Flex';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { PAYMENTS } from 'self-service-api/constants/Features';
import ChecklistItemTranslated from '../../common/ChecklistItemTranslated';
import { jsx as _jsx } from "react/jsx-runtime";
const BusinessObjectivesFeatures = ({
  features
}) => {
  return /*#__PURE__*/_jsx(List, {
    children: features.map(feature => {
      const secondaryMessage = feature.shortName === PAYMENTS ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.businessObjectives.usOnly"
      }) : null;
      return /*#__PURE__*/_jsx(Flex, {
        marginBlock: "100",
        children: /*#__PURE__*/_jsx(ChecklistItemTranslated, {
          tooltipMessage: /*#__PURE__*/_jsx(SanitizedText, {
            body: feature.description,
            formattingOptions: {
              isPlainText: false,
              shouldPreserveNewlines: true,
              shouldOpenLinksInNewTab: true
            }
          }),
          message: feature.displayName,
          secondaryMessage: secondaryMessage,
          isAvailable: 'isAvailable' in feature ? feature.isAvailable : undefined
        })
      }, feature.shortName);
    })
  });
};
export default BusinessObjectivesFeatures;